import authRoutes from "./authRoutes";
import dashboardRoutes from "./dashboardRoutes";
import leadsRoutes from "./leadsRoutes";
import loanApplicationRoutes from "./loanApplicationRoutes";
import ticketRoutes from "./ticketRoutes";
import camNoteRoutes from "./camNoteRoutes";
import employeeRoutes from "./employeeRoutes";
import bankerRoutes from "./bankerRoutes";
import billingRoutes from "./billingRoutes";
import delinkRoutes from "./delinkRoutes";
import profileRoutes from "./profileRoutes";
import securityRoutes from "./securityRoutes";
import subscriptionRoutes from "./subscriptionRoutes";
import commonRoutes from "./commonRoutes";
import autopayRoutes from "./autopayRoutes";

const appRoutes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...leadsRoutes,
  ...loanApplicationRoutes,
  ...ticketRoutes,
  ...camNoteRoutes,
  ...employeeRoutes,
  ...bankerRoutes,
  ...billingRoutes,
  ...delinkRoutes,
  ...profileRoutes,
  ...securityRoutes,
  ...subscriptionRoutes,
  ...commonRoutes,
  ...autopayRoutes,
];

export default appRoutes;
